<template>
    <div>
        <dv5-slide
            :view="slideContent"
            :swipe=true
            :swipeToSlide=true
            :responsive="[
                {
                    'breakpoint': 100000,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1
                    }
                },
                {
                    'breakpoint': 1920,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1
                    }
                },
                {
                    'breakpoint': 1366,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1
                    }
                },
                {
                    'breakpoint': 1024,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1
                    }
                },
                {
                    'breakpoint': 768,
                    'settings': {
                        'slidesToShow': 1,
                        'slidesToScroll': 1,
                        'rows': 1
                    }
                },
            ]"
        >
            <div
                class="slide-wrapper"
                :slot="'slide'"
                slot-scope="props"
                :class="props.slideClass"
            >
                <dv5-slide-component
                    :view="props.slide"/>
            </div>
        </dv5-slide>
    </div>
</template>

<script>
export default {
    name: 'dv5-initial-slide',
    props: ['view'],
    data(){
        return {
            slideContent: [],
            RouteAPI: null,
        }
    },
    created() {
        this.concatRoute();
    },
    mounted() {
    },
    methods: {
        concatRoute(){
            this.RouteAPI = '/' + this.view.data['lang'] + '/office/initial-carrousel'
            this.initialize()
        },
        initialize() {
            var vm = this;

            axios
                .get(`${ vm.RouteAPI }`)
                .then(function(resposta) {
                    if (resposta.data.success) {
                        // console.log(resposta.data.data)
                        vm.slideContent = resposta.data.data.initial_carrousel;
                    } else {
                        alertMsg(
                            "error",
                            vm.t.ocorreu_erro
                        );
                    }
                })
                .catch(function(error) {
                    //console.log(error);
                })
                .finally(function() {
                    vm.ready = true;
                });
        },
    }
}
</script>

<style scoped lang="scss">
@import '../../../../scss/extras/_variables';

.slide-wrapper{
    font-size: 10px;
    font-family: $dv5-font1;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/auth/InitialSlide.vue